<template>
  <div class="cardContainer">
      <lk-form :label-width="80"  :model='info' ref="form">
        <lk-row :gutter='16'>
          <lk-col span='14'>
            <lk-form-item label='合并症名称:'>
              <lk-input v-model="info.complication" :maxlength='50' v-if="able"></lk-input>
              <span v-else>{{info.complication || ''}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label="确诊日期:" prop="diagnosisTime">
              <timeStampDatePicker style="width:100%" ref="prescription4" placeholder='请选择'
                v-if='able' v-model="info.diagnosisTime "></timeStampDatePicker>
              <span v-else>{{info.diagnosisTime | formatDate}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='10'>
            <lk-form-item label='肾功能:'>
              <lk-radio-group v-model="info.veryFunction" v-if="able">
                <lk-radio :label='1'>正常</lk-radio>
                <lk-radio :label='2'>损害</lk-radio>
              </lk-radio-group>
              <span v-else>{{selectList1[info.veryFunction]}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='12'>
            <lk-form-item label='肝功能:'>
              <lk-radio-group v-model="info.liverFunction" v-if="able">
                <lk-radio :label='1'>正常</lk-radio>
                <lk-radio :label='2'>损害</lk-radio>
              </lk-radio-group>
              <span v-else>{{selectList1[info.liverFunction] || ''}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='8'>
            <lk-form-item label='吸烟量:'>
            <div style="display: flex">
              <NumberInput
                v-if='able'
                :maxlength='5'
                v-model='info.smokingVolume'
                size='default'
                placeholder="请输入"
              ></NumberInput>
              <span v-else>{{info.smokingVolume}}</span>
              <span style="width: 36px">包/日</span>
            </div>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-form-item label='饮酒量:'>
            <div style="display: flex">
              <NumberInput
                v-if='able'
                :maxlength='5'
                v-model='info.drinkingVolume'
                size='default'
                placeholder="请输入"
              ></NumberInput>
              <span v-else>{{info.drinkingVolume || ''}}</span>
              <span style="width: 36px">两/日</span>
            </div>
            </lk-form-item>
          </lk-col>
          <lk-col span='7'>
            <lk-form-item label='饮酒种类:'>
              <lk-select multiple v-model="info.drinkingTypeList" :disabled="!able">
                <lk-option v-for="(item, index) in beerList" :key="index" :value='index*1'>
                  {{ item }}
                </lk-option>
              </lk-select>
              <!-- <span v-else>{{beerList[info.drinkingTypeList]}}</span> -->
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='10'>
            <lk-form-item label='过敏史:'>
              <lk-radio-group v-model="info.foodAllergyHistory" v-if="able">
                <lk-radio :label='1'>有</lk-radio>
                <lk-radio :label='2'>无</lk-radio>
              </lk-radio-group>
              <span v-else>{{selectList[info.foodAllergyHistory]}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row v-if="info.foodAllergyHistory===1">
            <lk-col span='23'>
              <lk-form-item label=''>
                <div class="historyInput">
                  <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.foodAllergyHistoryDetail" clearable :disabled='!this.able && info.foodAllergyHistory === 1'></lk-input>
                </div>
              </lk-form-item>
            </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='10'>
            <lk-form-item label='遗传病史:'>
              <lk-radio-group v-model="info.familyHistory" v-if="able">
                <lk-radio :label='1'>有</lk-radio>
                <lk-radio :label='2'>无</lk-radio>
              </lk-radio-group>
              <span v-else>{{selectList[info.familyHistory]}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row v-if="info.familyHistory===1">
            <lk-col span='23'>
              <lk-form-item label=''>
                <div class="historyInput">
                  <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.familyHistoryDetail" clearable :disabled='!this.able && info.familyHistory === 1'></lk-input>
                </div>
              </lk-form-item>
            </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='10'>
            <lk-form-item label='既往病史:'>
              <lk-radio-group v-model="info.diseaseHistory" v-if="able">
                <lk-radio :label='1'>有</lk-radio>
                <lk-radio :label='2'>无</lk-radio>
              </lk-radio-group>
              <span v-else>{{selectList[info.diseaseHistory]}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row v-if="info.diseaseHistory===1">
          <lk-col span='23'>
            <lk-form-item label=''>
              <div class="historyInput">
                <lk-input placeholder='请输入' :maxlength='500' type="textarea" v-model.trim="info.diseaseHistoryDetail" clearable :disabled='!this.able && info.diseaseHistory === 1'></lk-input>
              </div>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row>
          <lk-col span='23'>
            <lk-form-item label='其它药物:'>
              <lk-input v-if="able" placeholder='除购买的药品以外，当前所用其他药物使用情况（如：处方药、非处方药、中药、保健品等）' :maxlength='25' v-model.trim="info.otherDrugs" clearable></lk-input>
              <span v-else>{{info.otherDrugs}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
  </div>
</template>

<script>
import Uploader from '../Uploader.vue';
import timeStampDatePicker from '../timeStampDatePicker.vue';

export default {
  name: 'OtherDiseaseCard',
  components: {
    Uploader,
    timeStampDatePicker
  },
  props: {
    diseaseQo: {
      type: Object,
    },
    able: {
      type: Boolean,
    },
  },
  model: {
    prop: 'diseaseQo',
    event: 'change',
  },
  computed: {
  },
  watch: {
    diseaseQo: {
      handler(val) {
        this.info = this.diseaseQo;
      },
      deep: true,
    },
  },
  data() {
    return {
      info: {
      },
      selectList:{
        1: '有',
        2: '无',
      },
      selectList1:{
        1: '正常',
        2: '损害',
      },
      beerList: {
        1: '白酒',
        2: '黄酒',
        3: '红酒',
        4: '洋酒',
      },
    }
  },
  methods: {
    handlerAddClick() {

    },
    onDelete(index) {
      this.goodsUsageInfo.medicalFaq.splice(index, 1)
    },
    validateForm() {
      this.$emit('change', this.info);
    },
  },

  created() {
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.cardContainer {
  .historyInput {
    /deep/ .ivu-input {
      height: 50px;
    }
  }
}
</style>
